import React, { Component } from 'react';

export default class Panel extends Component{

	render(){
        const { title, className, children } = this.props
		
		return(
            <div className={ "panel panel-default " + (className || '') }>
                <div className="panel-heading">{ title }</div>
                <div className="panel-body">
                    { children }
                </div>
            </div>
        )
	}
}


// WEBPACK FOOTER //
// ./src/components/Panel.jsx